import React, { useEffect, useState } from 'react';
import { getLabPriorityQueue } from '../api/smartiLabApi';
import LabCard from '../components/LabCard';
import LabMetric from '../components/LabMetric';
import LabRiskBadge from '../components/LabRiskBadge';
import LabTable from '../components/LabTable';
import { useSmartiLabContext } from '../SmartiLabContext';

export default function PriorityQueuePage() {
  const { sharedQuery } = useSmartiLabContext();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    getLabPriorityQueue(sharedQuery).then(setData).catch((err) => setError(err.message));
  }, [sharedQuery]);

  return (
    <div className="lab-page">
      <LabCard
        title="Coda priorità"
        description="Coda di triage trasversale costruita su evidenze reali di produzione e burn-in. Usa questa pagina per decidere cosa indagare per primo."
      >
        {error ? <p className="lab-error-text">{error}</p> : null}
        <div className="lab-metric-grid">
          <LabMetric label="Elementi prioritari" value={data?.summary?.totalItems ?? 0} />
          <LabMetric label="Critici" value={data?.summary?.criticalCount ?? 0} />
          <LabMetric label="Alti / warning" value={data?.summary?.highCount ?? 0} />
          <LabMetric
            label="Categoria principale"
            value={data?.summary?.categories?.[0]?.value || '—'}
          />
        </div>
      </LabCard>

      <LabCard
        title="Coda di indagine"
        description="Segnali misti di unità, stazioni, regressioni, near-limit, recidivi, burn-in e cross-link ordinati per impatto e urgenza."
      >
        <LabTable
          rows={data?.rows || []}
          emptyTitle="Nessun elemento prioritario"
          emptyDescription="Smarti Lab ha bisogno di più evidenza prima di costruire una coda di triage affidabile."
          columns={[
            { key: 'category', label: 'Categoria' },
            { key: 'title', label: 'Target' },
            { key: 'severity', label: 'Severità', render: (value) => <LabRiskBadge label={value} /> },
            { key: 'priorityScore', label: 'Priorità' },
            { key: 'summary', label: 'Sintesi' },
            { key: 'reasons', label: 'Evidenza', render: (value) => (value || []).join(', ') || '—' },
          ]}
        />
      </LabCard>
    </div>
  );
}
